// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Statistics_wrapper__1kJuN","header":"Statistics_header__1UO7l","stat":"Statistics_stat__1Iii_","subheader":"Statistics_subheader__2dLu6"};